"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportResultTypeEnum = void 0;
var ImportResultTypeEnum;
(function (ImportResultTypeEnum) {
    ImportResultTypeEnum["VALIDATION"] = "VALIDATION";
    ImportResultTypeEnum["CREATION"] = "CREATION";
})(ImportResultTypeEnum || (exports.ImportResultTypeEnum = ImportResultTypeEnum = {}));
